module.exports = __webpack_public_path__ + "static/images/tag-bg-92.73ea59f.png";